// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"4948135d","732":"52d5ba04","839":"326eb615"}[chunkId] + ".chunk.js";
};